import { useAppSelector } from 'src/store/reducers';
import { getIsMicrowebStep } from 'src/store/selectors/microwebSelectors';

import type { MicrowebStepFormDataCallBack } from './types/microwebstepTypes';

import { useMicrowebStepData } from '@helsenorge/step/hooks/useMicrowebStepData';

export const useCustomMicrowebStepFunctions = (): {
  onCompleteMicroweb?: MicrowebStepFormDataCallBack;
  sendPendingChangesEvent?: (hasChanges: boolean) => void;
} => {
  const { navigateForward, sendData } = useMicrowebStepData();

  const isMicrowebStep = useAppSelector(getIsMicrowebStep);

  const completeFunction: MicrowebStepFormDataCallBack = formData => {
    navigateForward(formData);
  };

  /** Sender pendingChanges eventet videre til konsumenten hvor evt. pop up håndteres der */
  const sendPendingChangesEvent = (hasChanges: boolean): void => {
    sendData({ hasPendingChanges: hasChanges });
  };

  return {
    onCompleteMicroweb: isMicrowebStep ? completeFunction : undefined,
    sendPendingChangesEvent: isMicrowebStep ? sendPendingChangesEvent : undefined,
  };
};

export default useCustomMicrowebStepFunctions;
